/*
1 - shuma is in progress
2 - shuma is pending admin review
3 - shuma review is rejected by admin
4 - shuma review is approved by admin - user can now compete the shuma
5 - shuma is completed
*/
export const shumaStatusTypeIds = {
  IN_PROGRESS: 1,
  PENDING_ADMIN_REVIEW: 2,
  REJECTED_BY_ADMIN: 3,
  APPROVED_BY_ADMIN: 4,
  COMPLETED: 5,
  PENDING_REVIEW: 6,
  PENDING_SIGNATURE: 7,
  COMPLETED_MANUALLY: 8,
  FROZEN: 9,
};
